<template>
  <div class="page-calendar">
    <quick-dates @calendar="toggleCalendar" />
    <div class="calendar-content" v-show="!show_calendar">
      <div class="calendar" />
      <div class="invite" />
      <Course v-for="course in courses" :course="course" :key="course.id" />
      <weui-button-area>
        <weui-button type="primary" @click="newCourse">添加课程</weui-button>
        <weui-button type="default" @click="invite">邀请会员约课</weui-button>
      </weui-button-area>
      <app-tour />
    </div>
    <calendar-view v-show="show_calendar" />
  </div>
</template>

<script>
import { WeuiButton, WeuiButtonArea } from '@/components/weui';
import { createNamespacedHelpers } from 'vuex';

import QuickDates from '@/components/calendar/QuickDates';
import AppTour from '@/components/calendar/AppTour';
import Course from '@/components/calendar/Course';
import CalendarView from '@/components/calendar/CalendarView';
import datetimeUtils from '@/utils/datetime';

import { ROUTE_INVITE, ROUTE_COURSE_BOOT_TRAINERS } from '@/router/names';
import { CHANGE_DATE } from '@/store/calendar/types';

const { mapState, mapActions } = createNamespacedHelpers('calendar');

export default {
    name: 'Calendar',
    data() {
        return {
            show_calendar: false,
        };
    },
    computed: {
        ...mapState([
            'date',
            'courses',
        ]),
    },
    watch: {
        date() {
            this.show_calendar = false;
        },
    },
    created() {
        const { date } = this.$route.query;
        if (date && datetimeUtils.filterDate(date)) {
            this.changeDate({ date });
        } else {
            this.changeDate({
                date: datetimeUtils.getToday(true),
            });
        }
    },
    methods: {
        ...mapActions({
            changeDate: CHANGE_DATE,
        }),
        toggleCalendar() {
            this.show_calendar = !this.show_calendar;
        },
        newCourse() {
            this.$router.push({
                name: ROUTE_COURSE_BOOT_TRAINERS,
                query: {
                    date: this.date,
                },
            });
        },
        invite() {
            this.$router.push({
                name: ROUTE_INVITE,
            });
        },
    },
    components: {
        WeuiButton,
        WeuiButtonArea,
        QuickDates,
        Course,
        AppTour,
        CalendarView,
    },
};
</script>

<style lang="scss">
.page-calendar {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100vh;
}
.quick-dates {
    flex: none;
}
.calendar-content, .calendar-view {
    flex: auto;
    overflow-y: scroll;
    position: relative;
    -webkit-overflow-scrolling: touch;
}

.course {
    margin-top: 7.333333333vw;
}
</style>



// WEBPACK FOOTER //
// src/containers/calendar/Index.vue